import {
    type ContextProps,
    FeaturesProvider,
    useFlags,
    type WorkspaceContextType,
    type WorkspaceFeatures,
    workspaceFeatures,
} from "@expert/features";
import type { Logger } from "@expert/logging";
import type React from "react";
import { useMemo } from "react";
import { env } from "@/config";
import { usePartner } from "@/sdk";

interface WorkspaceFeatureFlagsProps {
    children: React.ReactNode;
    employeeId: string | null;
    logger: Logger;
}

export function WorkspaceFeatureFlags({ children, employeeId, logger }: WorkspaceFeatureFlagsProps) {
    const partner = usePartner();

    const context = useMemo(() => {
        return {
            appName: "expert-workspace",
            employeeId,
            environment: env.mode,
            channel: env.channel,
            partner,
            source: "expert-ui",
        } as ContextProps;
    }, [employeeId, partner]);

    const features = useFlags<WorkspaceContextType>({
        analyticGroup: "Workspace",
        context,
        features: workspaceFeatures,
        logger,
    }) as WorkspaceFeatures;

    return <FeaturesProvider features={features}>{children}</FeaturesProvider>;
}
